<template>
  <div>
    <table-with-search
      :items="employees"
      :headers="allHeaders"
      :openDialog="openDialog"
      @headersUpdated="updateHeaders"
      @refreshItems="refreshItems"
      :showRefresh="true"
      :showPagination="true"
      :itemsPerPage="20"
    />
    <v-dialog
      v-model="openForm"
      max-width="550px"
      persistent
      :key="mode"
      @keydown.esc="reset(false)"
    >
      <Form
        @save="saveForm"
        @cancel="reset"
        :maxWidth="maxWidth"
        :mode="mode"
        :show="true"
        :showCheck="true"
        :isDisabled="isDisabled"
        :itemsSelect="dataSelected"
        :showDate="true"
        :key="formKey"
        :itemsCheckbox="defaultGrp"
      >
      </Form>
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
    <DeleteDialog
      :showDialog="openDelete"
      :title="titleDelete"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
    />
    <v-dialog
      v-model="isLoading"
      class="dialog__loader"
      :overlay-opacity="0.3"
      persistent
    >
      <Loader :loading="isLoading" />
    </v-dialog>
  </div>
</template>
<script>
import groups from "../../../store/groups/groups";
import TableWithSearch from "../../Complement/TableWithSearch.vue";
import employeesGroups from "../../../store/groups/employees";
import Snackbar from "../../Complement/Snackbar.vue";
import Form from "../../Complement/Form.vue";
import date from "../../../store/common/date";
import DeleteDialog from "../../Complement/DeleteDialog.vue";
import Loader from "../../Complement/Loader.vue";
import moment from "moment";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: { Loader, TableWithSearch, Snackbar, Form, DeleteDialog },
  data() {
    return {
      titleTable: "Grupos_Empleados",
      formKey: 0,
      headers: [
        {
          text: "Nombre",
          value: "fullName",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Legajo",
          value: "file",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Desde",
          value: "from",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Hasta",
          value: "to",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "150px",
        },
      ],
      openForm: false,
      openForm: false,
      alert: false,
      textAlert: "",
      color: null,
      maxWidth: "550px",
      titleDelete: this.$tc("groups.toEmployee"),
      itemToDelete: null,
      isLoading: false,
      itemsToEdit: null,
      isDisabled: false,
      type: null,
      oldFrom: null,
      defaultGrp: [
        {
          name: "defaultGrp",
          label: "Predetermiando",
          data: false,
        },
      ],
      order: "apellido",
    };
  },
  async mounted() {
    await this.$store.dispatch("employees/getEmployees", {
      photo: false,
      order: this.order,
      soloActivos: true,
    });
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  },

  computed: {
    allHeaders() {
      return Array.isArray(configTable.state?.colums)
        ? configTable.state.colums
        : [];
    },
    employees() {
      return employeesGroups.state.employees || [];
    },
    title() {
      return groups.state.itemSelected.son;
    },
    dataSelected() {
      return [
        {
          name: "employees",
          label: this.$tc("groups.employees"),
          data: [],
          items: [],
          itemsValue: "empId",
          itemsText: (item) => `${item.fullName} (${item.file})`,
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          readonly: false,
        },
      ];
    },
    mode: {
      get() {
        return employeesGroups.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    filterEmployees() {
      const filter = this.$store.state.employees.employees?.filter(
        (emp) =>
          !employeesGroups.state.employees.some((e) => e.empId === emp.empId),
      );
      return filter;
    },
    openDelete: {
      get() {
        return employeesGroups.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    allEmployees() {
      return this.$store.state.employees.employees;
    },
  },
  methods: {
    async refreshItems() {
      if (groups.state.itemSelected.id) {
        const groupId = groups.state.itemSelected.id;
        await employeesGroups.dispatch("getEmployees", groupId);
      }
    },
    updateHeaders(headers) {
      const updatedColums = { ...configTable.state.colums, empleados: headers };
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        Object.values(columnsToSave).reduce(
          (sum, array) => sum + array.length,
          0,
        ) !==
          Object.values(this.headers).reduce(
            (sum, array) => sum + array.length,
            0,
          ) ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    async openDialog(type, item) {
      this.type = type;
      switch (type) {
        case "add":
          if (this.validGroup()) {
            employeesGroups.commit("setOpenEmployees", true);
            this.openForm = true;
            employeesGroups.commit("setMode", this.$tc("groups.addEmpTitle"));
            this.dataSelected[0].items = this.filterEmployees;
          }
          break;

        case "edit":
          if (item.defaultGrp === "✔️") {
            this.defaultGrp[0].data = true;
          } else {
            this.defaultGrp[0].data = false;
          }
          this.dataSelected[0].items = this.allEmployees;
          await this.seteoItems(item);
          employeesGroups.commit("setOpenEmployees", true);

          break;
        case "delete":
          employeesGroups.commit("setOpenDelete", true);
          this.itemToDelete = item;
          break;
        default:
          break;
      }
    },
    seteoItems(item) {
      this.openForm = true;
      employeesGroups.commit("setMode", this.$tc("groups.editEmpTitle"));
      this.itemsToEdit = item;

      this.dataSelected[0].data = item.empId;
      this.dataSelected[0].readonly = true;
      date.commit("setDateFrom", this.formatDate(item.from));
      date.commit("setDateTo", item.to == "" ? null : this.formatDate(item.to));
      date.commit("setCheckTo", item.to == "" ? true : false);
      this.oldFrom = this.formatDate(item.from);
    },
    formatDate(item) {
      const dateToFormat = moment(item, "DD-MM-YYYY");
      let date = dateToFormat.format("YYYY-MM-DD");

      return date;
    },
    loading() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 2500);
    },

    validGroup() {
      if (groups.state.itemSelected.son) {
        return true;
      } else {
        this.showAlert(
          (this.textAlert = this.$tc("groups.selectGroup")),
          "error",
        );

        return false;
      }
    },
    reset(value) {
      this.resetDate();
      employeesGroups.commit("setOpenEmployees", value);
      this.openForm = value;
      this.alert = false;
      this.dataSelected.forEach((item) => {
        item.data = "";
        item.readonly = false;
      });
    },
    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },
    saveForm(value) {
      let empId = parseInt(value.employees, 10);
      let employee = this.getName(empId);
      let payload = {
        from: date.state.dateFrom,
        to: date.state.checkTo ? undefined : date.state.dateTo,
        empId: empId,
        name: employee.name,
        lastName: employee.lastName,
        groupId: groups.state.itemSelected.id,
        oldFrom: this.oldFrom ? this.oldFrom : undefined,
        defaultGrp: value.defaultGrp == "true" ? "S" : "N",
      };

      if (this.type == "add") {
        this.addEmployee(payload);
      } else {
        this.editEmployee(payload);
      }
    },
    addEmployee(payload) {
      employeesGroups.commit("setNew", payload);
      employeesGroups
        .dispatch("new")
        .then(() => {
          this.showAlert(
            (this.textAlert = this.$tc("groups.addEmployee")),
            "primary",
          );
          if (groups.state.itemSelected.id) {
            const groupId = groups.state.itemSelected.id;
            employeesGroups.dispatch("getEmployees", groupId);
          }
        })
        .catch((e) => {
          this.showAlert(
            (this.textAlert = this.$tc("groups.errorEmp")),
            "error",
          );
        });
      this.reset(false);
    },
    editEmployee(payload) {
      employeesGroups.commit("setEdit", payload);
      employeesGroups
        .dispatch("edit")
        .then(() => {
          this.showAlert(
            (this.textAlert = this.$tc("groups.editEmp")),
            "primary",
          );
          if (groups.state.itemSelected.id) {
            const groupId = groups.state.itemSelected.id;
            employeesGroups.dispatch("getEmployees", groupId);
          }
        })
        .catch((e) => {
          console.log(e);
          this.showAlert(
            (this.textAlert = this.$tc("groups.errorEditEmp")),
            "error",
          );
        });
      this.reset(false);
    },
    getName(id) {
      const employee = this.$store.state.employees.employees.find(
        (emp) => emp.empId === id,
      );
      return employee;
    },
    deleteItem() {
      employeesGroups.commit("setDeleteItem", this.itemToDelete);
      employeesGroups
        .dispatch("delete")
        .then(() => {
          employeesGroups.commit("setOpenDelete", false);
          this.showAlert(
            (this.textAlert = this.$tc("groups.deleteEmp")),
            "primary",
          );
        })
        .catch((e) => {
          this.showAlert(this.$tc("groups.errorDeleteEmp"), "error");
        });
    },
    cancelDelete() {
      this.openDelete = false;
      employeesGroups.commit("setOpenDelete", false);
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
  },
};
</script>
